var InitialiseRegisterLogin = function () {

    var phoneNumber = $("#lblPhoneNumber").text();

    Heading.StoreCurrent();

    Cli.GetCliVerification(null, phoneNumber, function (data) {
        if (data.CliVerificationDto) {
            if (data.CliVerificationDto.CliVerificationTypeId) {
                pollingOnRunning = true;
                CheckCliVerification(phoneNumber);
                ShowCliVerificationStatus(data.CliVerificationDto.CliVerificationTypeId, data.CliVerificationDto.CliVerificationStatusId, true);
            }
        }
    });

    $("#btnYouCallUs").on("click", function () {
        Cli.InitialiseCliVerification(null, phoneNumber, Cli.CliVerificationType.inboundCallPlayPassword, function (data) {
            if (data.CliVerificationDto && data.CliVerificationDto.CliVerficationStatusId == Cli.CliVerification.Status.Requested &&
                data.CliVerificationDto.CliVerificationTypeId == Cli.CliVerificationType.inboundCallPlayPassword) {
                pollingOnRunning = true;
                ShowCliVerificationStatus(Cli.CliVerificationType.inboundCallPlayPassword, data.CliVerificationDto.CliVerficationStatusId, true);
                CheckCliVerification(phoneNumber);
            }
            else {
                // Error
                var cliVerficationStatusId = -1;
                if (data.CliVerificationDto) cliVerficationStatusId = data.CliVerificationDto.CliVerficationStatusId;
                ShowCliVerificationStatus(Cli.CliVerificationType.inboundCallPlayPassword, cliVerficationStatusId, false);
            }
        });
    });

    $("#btnWeCallYou").on("click", function () {
        Cli.InitialiseCliVerification(null, phoneNumber, Cli.CliVerificationType.outboundCallPlayPassword, function (data) {
            if (data.CliVerificationDto && data.CliVerificationDto.CliVerficationStatusId == Cli.CliVerification.Status.Requested &&
                data.CliVerificationDto.CliVerificationTypeId == Cli.CliVerificationType.outboundCallPlayPassword) {
                pollingOnRunning = true;
                ShowCliVerificationStatus(Cli.CliVerificationType.outboundCallPlayPassword, data.CliVerificationDto.CliVerficationStatusId, true);
                CheckCliVerification(phoneNumber);
            }
            else {
                // Error
                var cliVerficationStatusId = -1;
                if (data.CliVerificationDto) cliVerficationStatusId = data.CliVerificationDto.CliVerficationStatusId;
                ShowCliVerificationStatus(Cli.CliVerificationType.outboundCallPlayPassword, cliVerficationStatusId, false);
            }
        });
    });

    $("#btnResetLandline").on("click", function () {
        Cli.CancelCliVerification(null, phoneNumber, function (data) {
            if (data.CliVerificationDto) {
                if (data.CliVerificationDto.CliVerficationStatusId == Cli.CliVerification.Status.Cancelled) {
                    ResetCliVerificationLandLine();
                }
            }
            else {
                ResetCliVerificationLandLine();
            }
        });

    });

    $(".buy_button").addClass("aspNetDisabled").children("a").attr('disabled', 'disabled');

    $(".buy_button > a").click(function (event) {
        if ($(this).attr("disabled") == "disabled") {
            event.preventDefault();
            $("#needLoginMessage").removeClass("hidden");

            //  alert($("#msg-login-needed").val());
        }
    });

    $("#btnLoginRegisterNew").click(function () {
        if (Page_ClientValidate("AllValidators")) {
            var login = phoneNumber;
            var password = $("#txtPassword").val();

            var data = { login: login, password: password };
            RegisterSimplifiedLoginStarted();
            $.ajax({
                data: JSON.stringify(data),
                type: "POST",
                contentType: "application/json; charset=utf-8",
                url: REGISTERLOGIN,
                dataType: "json",
                timeout: 60000,
                success: function (response, textStatus, jqXHR) {
                    if (typeof (fourdHandleAjaxSuccess) != 'undefined') {
                        fourdHandleAjaxSuccess(response, textStatus, jqXHR, this);
                    }
                    var responseData = GetNormalisedAjaxResponse(response);
                    var isLoggedIn = false;
                    if (responseData) {
                        if (responseData.IsAuthenticated) {
                            if (responseData.RedirectUrl != null && responseData.RedirectUrl.length > 0) {
                                // TODO - remove/update temp offer check logic
                                var currentURL = window.location;
                                var host = window.location.host;
                                var hostname = window.location.hostname;
                                var protocol = window.location.protocol;
                                var port = window.location.port;

                                var currentHostname = (port === 80 || port === 443) ? hostname : host;

                                window.location = protocol + '//' + currentHostname + responseData.RedirectUrl;
                            }
                            else {
                                //remove click event for login
                                $("#btnLoginRegisterNew").off("click");

                                //disable login controls
                                $("#btnLoginRegisterNew").addClass("aspNetDisabled").removeAttr("href");
                                $(".register-new.mobile-number").addClass("aspNetDisabled").attr('disabled', 'disabled');
                                $(".register-new.password").addClass("aspNetDisabled").attr('disabled', 'disabled');

                                //Enable buy buttons 
                                $(".buy_button").removeClass("aspNetDisabled").children("a").removeAttr("disabled");
                                isLoggedIn = true;
                                RegisterSimplifiedLoginSuccessful();
                            }
                        }
                        else {
                            //set login error message
                            $("#valPasswordAsync").attr("style", "");
                        }
                    }
                    RegisterSimplifiedLoginEnded(isLoggedIn);
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (typeof (fourdHandleAjaxError) != 'undefined') {
                        fourdHandleAjaxError(jqXHR, textStatus, errorThrown, this);
                    }
                    //callback({}); //looks like a bxslider function
                    RegisterSimplifiedLoginEnded(false);
                }
            });

        }

    });
}

var pollingOnRunning = false;

function CheckCliVerification(cli) {

    Cli.GetCliVerification(null, cli, function (data) {
        if (pollingOnRunning) {
            if (data.CliVerificationDto) {
                var statusConfiguration = Cli.CliVerification.StatusConfiguration[Cli.CliVerification.StatusConfiguration.map(function (element) { return element.status; }).indexOf(data.CliVerificationDto.CliVerficationStatusId)];

                if (statusConfiguration && statusConfiguration != "") {
                    if (statusConfiguration.type == Cli.CliVerification.StatusType.waiting) {

                        if (data.CliVerificationDto.RequestCanBeCancelled) {
                            $("#divResetLandline").removeClass("hidden");
                        }
                        else {
                            $("#divResetLandline").addClass("hidden");
                        }
                        setTimeout(function () { CheckCliVerification(cli); }, Cli.ClientConfigurations.DefaultPollingTime);
                    }
                    else {
                        pollingOnRunning = false;
                        $("#divResetLandline").removeClass("hidden");
                    }
                    $("#iconStatus").attr("href", statusConfiguration.svgHref);
                    $("#spanStatusText").text(statusConfiguration.label);
                }
                else {
                    pollingOnRunning = false;
                    $("#divResetLandline").removeClass("hidden");
                }
            }
            else {
                pollingOnRunning = false;
                $("#divResetLandline").removeClass("hidden");
            }
        }
    });
}

function ResetCliVerificationLandLine() {
    pollingOnRunning = false;
    $("#btnWeCallYou").attr("disabled", false).show();
    $("#btnYouCallUs").attr("disabled", false).show();
    $("#liPassw0rd").addClass("hidden");
    $("#contentWeCallYou").addClass("hidden");
    $("#contentCallUs").addClass("hidden");
    $("#buttonLoginContent").addClass("hidden");
    $("#divStatus").addClass("hidden");
    $("#divResetLandline").addClass("hidden");
    $("#spanStatusText").text("Requested");
    $("#iconStatus").attr("href", "#icon-wait");
    Heading.Reset();
}

function RegisterSimplifiedLoginSuccessful() {
    $("#loginForm").hide();
    $("#paymentOptions").removeClass("disabled");
    $("#needLoginMessage").addClass("hidden");
    $("#notLoggedInContent").addClass("hidden");
    $("#LoggedInContent").removeClass("hidden");
}

function RegisterSimplifiedLoginStarted() {
    $("#btnLoginRegisterNew").addClass("aspNetDisabled").attr("disabled", "disabled");
    $("#Loginspan").addClass("hidden");
    $("#loading").removeClass("hidden");
}

function RegisterSimplifiedLoginEnded(isLoggedIn) {
    if (isLoggedIn == false)
        $("#btnLoginRegisterNew").removeClass("aspNetDisabled").removeAttr("disabled");
    $("#loading").addClass("hidden");
    $("#Loginspan").removeClass("hidden");
}

var Heading = {
    element: $("#notLoggedInContent")
   , html: null
   , htmlTemplate: "<h1></h1></br><p></p>"
   , StoreCurrent: function () {
       Heading.html = Heading.element.html();
   }
   , Set: function (h1, p) {
       Heading.element.html(Heading.htmlTemplate);
       Heading.element.children("h1").text(h1);
       Heading.element.children("p").text(p);
   }
   , Reset: function () {
       Heading.element.html(Heading.html);
   }
}

function ShowCliVerificationStatus(cliVerificationTypeId, cliVerficationStatusId, showVerifyingHeading) {
    $("#btnYouCallUs").hide();
    $("#btnWeCallYou").hide();
    $("#liPassw0rd").removeClass("hidden");
    $("#buttonLoginContent").removeClass("hidden");
    $("#divStatus").removeClass("hidden");

    if (cliVerificationTypeId == Cli.CliVerificationType.inboundCallPlayPassword) {
        $("#contentWeCallYou").addClass("hidden");
        $("#contentCallUs").removeClass("hidden");
    } else if (cliVerificationTypeId == Cli.CliVerificationType.outboundCallPlayPassword) {
        $("#contentWeCallYou").removeClass("hidden");
        $("#contentCallUs").addClass("hidden");
    }

    var statusConfiguration = Cli.CliVerification.StatusConfiguration[Cli.CliVerification.StatusConfiguration.map(function (element) { return element.status; }).indexOf(cliVerficationStatusId)];
    if (statusConfiguration && statusConfiguration != "") {
        $("#iconStatus").attr("href", statusConfiguration.svgHref);
        $("#spanStatusText").text(statusConfiguration.label);
    }

    if (showVerifyingHeading) {
        Heading.Set("Verifying your phone number", "Please now enter the password issued by our service to continue.");
    }
}